import * as PIXI from "pixi.js";
import {config} from "../config";
import {PredefinedPIXIAnchorPoint} from "../PredefinedPIXIAnchorPoint";
import data from "./configs/data";

export class InfoTextField extends PIXI.Container {

    private readonly HEADER_TEXT_POSITION: any = new PIXI.Point(-120, -5);
    private readonly CURRENCY_TYPE_POSITION = new PIXI.Point(122, -4);
    private readonly VALUE_POSITION = new PIXI.Point(70, -5);

    private readonly HEADER_TEXT_STYLE = {
        fontSize: 21,
        fontFamily: "RobotoMedium",
        fill: "#fff",
    };

    private readonly VALUE_TEXT_STYLE = {
        fontSize: 20,
        fontFamily: "RobotoRegular",
        fill: "#ffffff",
    };

    private readonly CURRENCY_TEXT_STYLE = {
        fontSize: 17,
        fontFamily: "RobotoRegular",
        fill: "#fff",
    };

    private valueText: PIXI.Text;
    private currencyText: PIXI.Text;

    constructor(headerText: string) {
        super();
        this.createAndAddBackground();
        this.createHeaderText(headerText);
        this.createAndAddValueText();
        this.createAndAddCurrencyTypeText();
    }

    public setValue(value: string, currencyType: string): void {
        this.valueText.text = value;
        this.currencyText.text = config.displayCurrency;
    }

    private createAndAddValueText(): void {
        this.valueText = new PIXI.Text("", this.VALUE_TEXT_STYLE);
        this.valueText.position = this.VALUE_POSITION;
        this.valueText.anchor = PredefinedPIXIAnchorPoint.RIGHT_ALIGN;
        this.addChild(this.valueText);
    }

    private createAndAddCurrencyTypeText(): void {
        this.currencyText = new PIXI.Text("", this.CURRENCY_TEXT_STYLE);
        this.currencyText.position = this.CURRENCY_TYPE_POSITION;
        this.currencyText.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
        this.currencyText.anchor.x = 1;
        this.addChild(this.currencyText);
    }

    private createHeaderText(text: string): void {
        const headerText = new PIXI.Text(text, this.HEADER_TEXT_STYLE);
        headerText.position = this.HEADER_TEXT_POSITION;
        headerText.anchor = PredefinedPIXIAnchorPoint.LEFT_ALIGN;
        this.addChild(headerText);
    }

    private createAndAddBackground(): void {
        const background: PIXI.Sprite = PIXI.Sprite.fromImage(data.images.textFieldBackground);
        background.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(background);
    }
}



// WEBPACK FOOTER //
// ./src/app/InfoTextField.ts